import { TransactionCardPaymentFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import AmountWithCurrency from 'modules/expenses/lib/transactions/AmountWithCurrency'

import { CustomDetails } from '../CustomDetails'
import { CustomPairTransactionDetails } from '../CustomPairTransactionDetails'

export const CardPaymentDetails = (cardPayment: TransactionCardPaymentFragment) => {
  if (!cardPayment) return null

  return (
    <CustomDetails>
      <CustomPairTransactionDetails
        desc1={i18n.t('expenses_v2.transactions.detail.fields.original_amount')}
        val1={
          <AmountWithCurrency
            amount={Number(cardPayment.merchantAmountCents)}
            currency={cardPayment.merchantCurrency}
          />
        }
        desc2={i18n.t('expenses_v2.transactions.detail.fields.exchange_rate')}
        val2={cardPayment.exchangeRate != 1 ? cardPayment.exchangeRate : null}
      />
    </CustomDetails>
  )
}
